export const GET_SUBSCRIPTION_PLANS = 'GET_SUBSCRIPTION_PLANS'
export const SUBSCRIPTION_PLANS_REQUESTED = 'SUBSCRIPTION_PLANS_REQUESTED'
export const GET_FAQ = 'GET_FAQ'
